// extracted by mini-css-extract-plugin
export default {"range":"Title_range__sSm04","popover":"Title_popover__Tvhvo"};